import { createAction, props } from "@ngrx/store";
import { ClientSidePermissionContainerModel, ClientSidePermissionRoleLinkContainerModel, ClientSidePermissionTeamLinkContainer } from "blg-akaun-ts-lib";
import { ClientSideViewModel } from "../states/client-side-permission.states";

export const clientSidePermissionsInit = createAction(
  '[Client Side Perm] Load Client Side Permissions Init',
   props<{ request: any }>()
);

// export const clientSidePermissionsSuccess = createAction(
//   '[Client Side Perm] Load Client Side Permissions Success',
//   props<{permissions: ClientSidePermissionTeamLinkContainer[]}>()
// );

export const clientSidePermissionsSuccess = createAction(
  '[Client Side Perm] Load Client Side Permissions Success',
  props<{permissions: ClientSideViewModel[]}>()
);

export const clientSidePermissionsFailed = createAction(
  '[Client Side Perm] Load Client Side Permissions Failed',
  props<{error: string}>()
);

export const createClientSidePermInit = createAction('[Client Side Perm] Create Client Side Perm Init', props<{clientSidePerm: ClientSidePermissionRoleLinkContainerModel}>());
export const createClientSidePermSuccess = createAction('[Client Side Perm] Create Client Side Perm Success');
export const createClientSidePermFailure = createAction('[Client Side Perm] Create Client Side Perm Failure', props<{error: string}>());

export const updateClientSidePermInit = createAction('[Client Side Perm] Update Client Side Perm Init', props<{clientSidePerm: ClientSidePermissionRoleLinkContainerModel}>());
export const updateClientSidePermSuccess = createAction('[Client Side Perm] Update Client Side Perm Success');
export const updateClientSidePermFailure = createAction('[Client Side Perm] Update Client Side Perm Failure', props<{error: string}>());

export const deleteClientSidePermInit = createAction('[Client Side Perm] Delete Client Side Perm Init');
export const deleteClientSidePermSuccess = createAction('[Client Side Perm] Delete Client Side Perm Success');
export const deleteClientSidePermFailure = createAction('[Client Side Perm] Delete Client Side Perm Failure', props<{error: string}>());

export const selectClientSidePerm = createAction('[Client Side Perm] Select Client Side Perm', props<{clientSidePerm: ClientSidePermissionRoleLinkContainerModel}>());

export const setUpdatePermSetListing = createAction('[Client Side Perm] Set Update Perm Set Listing', props<{update: boolean}>());

export const createTenantClientSidePermInit = createAction('[Client Side Perm] Create Client Side Perm Init', props<{clientSidePerm: ClientSidePermissionContainerModel}>());
export const createTenantClientSidePermSuccess = createAction('[Client Side Perm] Create Client Side Perm Success');
export const createTenantClientSidePermFailure = createAction('[Client Side Perm] Create Client Side Perm Failure', props<{error: string}>());